export const requirementsData = {
    my: {
        title: "စာသင်သားသံဃာသစ်များ ယူလာရမည့်ပစ္စည်း",
        subtitle: "သဒ္ဓါတရားသာ ယူလာခဲ့ပါ",
        sections: [
            {
                title: "ဝိနည်းနှင့်အညီ",
                content: "မဟာဝိဟာရကျောင်းတိုက်သည် ဝိနည်းအဓိကထားသည့် စာသင်တိုက်ဖြစ်သော ကြောင့် ဝိနည်းတော်နှင့် မညီသော ပစ္စည်းများ မယူလာရ"
            },
            {
                title: "တားမြစ်ထားသောပစ္စည်းများ",
                content: "သီလကို ညစ်နွမ်းစေသော ဖုန်း၊ ကွန်ပျူတာ စသော ခေတ်အသုံးအဆောင် ပစ္စည်းများ မယူလာရ"
            },
            {
                title: "သံဃိကဘဏ္ဍာတိုက်",
                content: "မဟာဝိဟာရတွင် သံဃိကဘဏ္ဍာတိုက်မှ သပိတ်, သင်္ကန်း, ရေချိုးခွက်၊ ဆပ်ပြာစသော လိုအပ်သည်များကို လှူဒါန်းပေးလျက် ရှိပါ၏"
            },
            {
                title: "စေတနာရှင်များ၏ထောက်ပံ့မှု",
                content: "စာသင်သားတို့သုံးရန် မဖြစ်မနေလိုအပ်သော ပစ္စည်းများကို စေတနာရှင်တို့က တိုက်ရိုက်လှူဒါန်းခြင်း"
            }
        ]
    },
    en: {
        title: "Required Items for New Student Monks",
        subtitle: "Just Bring Faith",
        sections: [
            {
                title: "Vinaya Compliance",
                content: "As Mahãvihãra Monastery focuses on Vinaya, items not in accordance with monastic rules are prohibited"
            },
            {
                title: "Prohibited Items",
                content: "Modern devices such as phones and computers that may compromise moral discipline are not allowed"
            },
            {
                title: "Sanghika Treasury",
                content: "The monastery provides alms bowls, robes, bathing vessels, soap, and other essentials through its Sanghika Treasury"
            },
            {
                title: "Donor Support",
                content: "Necessary items are provided through direct donations from supporters and redistributed items from the Sangha"
            }
        ]
    }
};